import { reactStyling, tokens } from '@getgo/chameleon-core';
import { makeStyles } from '@material-ui/core';
const useTextFieldStyles = makeStyles((theme) => {
    const { textField, textFieldHover, textFieldSmall, textFieldLarge, textFieldXlarge, textFieldDanger, textFieldDangerFocus, textFieldSuccess, textFieldSuccessFocus, } = reactStyling(theme.tokens);
    return {
        field: {
            maxWidth: 320,
            width: '100%',
        },
        fullWidth: {
            maxWidth: 'unset',
        },
        readOnly: {
            // @ts-ignore
            [`& .${window.CLASSNAME_PREFIX}-MuiInputBase-root`]: {
                backgroundColor: tokens.disabled02,
                color: tokens.text01,
            },
        },
        minWidth: {
            maxWidth: 240,
            minWidth: 240,
        },
        adornment: {
            fontSize: 16,
            color: tokens.neutral500,
        },
        root: Object.assign(Object.assign({}, textField), { overflow: 'hidden', '&:hover:not(.Mui-disabled):not($focused)': Object.assign({}, textFieldHover), '&$focused': {
                boxShadow: tokens.highlightSmall,
                border: `1px solid ${tokens.focus}`,
            }, '&.Mui-disabled': {
                color: tokens.text03,
                borderColor: tokens.disabled04,
                backgroundColor: tokens.disabled02,
            } }),
        small: Object.assign(Object.assign({}, textFieldSmall), { padding: '6px 12px 6px 12px', 
            // @ts-ignore
            [`& .${window.CLASSNAME_PREFIX}-MuiInputBase-input`]: {
                height: 19,
            } }),
        medium: {
            padding: '10px 12px 10px 12px',
            // @ts-ignore
            [`& .${window.CLASSNAME_PREFIX}-MuiInputBase-input`]: {
                height: 22.4,
            },
        },
        large: Object.assign(Object.assign({}, textFieldLarge), { padding: '11px 12px 11px 12px', 
            // @ts-ignore
            [`& .${window.CLASSNAME_PREFIX}-MuiInputBase-input`]: {
                height: 22.4,
            } }),
        xlarge: Object.assign(Object.assign({}, textFieldXlarge), { padding: '11px 12px 11px 12px', 
            // @ts-ignore
            [`& .${window.CLASSNAME_PREFIX}-MuiInputBase-input`]: {
                height: 22.4,
            } }),
        area: {
            padding: '12px 12px 11px 12px',
            height: 'auto',
        },
        invalid: Object.assign(Object.assign({}, textFieldDanger), { '&:hover:not(.Mui-disabled):not($focused)': Object.assign({}, textFieldDanger), '&$focused': Object.assign({}, textFieldDangerFocus), '& chameleon-svg': {
                color: tokens.danger01,
            } }),
        success: Object.assign(Object.assign({}, textFieldSuccess), { '&:hover:not(.Mui-disabled):not($focused)': Object.assign({}, textFieldSuccess), '&$focused': Object.assign({}, textFieldSuccessFocus), '& chameleon-svg': {
                color: tokens.success01,
            } }),
        successIcon: {
            color: tokens.success01,
        },
        focused: {},
        label: {
            color: tokens.text01,
        },
        disabledText: {
            color: tokens.text03,
        },
    };
});
export default useTextFieldStyles;
